export class Filters {
  constructor(newCount, usedCount) {
    this.inventoryType = {
      types: [],
      newCount,
      usedCount
    };

    this.vin = '';
    this.stockNumber = '';
    this.year = {
      value: '',
      options: []
    };
    this.make = {
      value: '',
      options: []
    };
    this.model = {
      value: '',
      options: []
    };
    this.trim = {
      value: '',
      options: []
    };
  }

  build(filtersData) {}
}

export class FiltersMap {
  map = filterData => {
    // Inventory Type
    const newCount = filterData.types.NEW;
    const usedCount = filterData.types.USED;

    const filters = new Filters(newCount, usedCount);

    // Makes
    filters.make.options = Object.keys(filterData.makes);

    // Years
    filters.year.options = Object.keys(filterData.years);

    // Model
    filters.model.options = Object.keys(filterData.models);

    // Trim
    filters.trim.options = Object.keys(filterData.trims);

    return new Promise(function(resolve, reject) {
      resolve(filters);
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/vehicles/filters.model.js